export default "__VITE_ASSET__8cea786b__"